import { downloadFile } from '@chocolate-soup-inc/cs-api-consumer-utils';
import * as XLSX from 'xlsx';

export type TReportSheet = (number | string | null | undefined)[][];
export type TReportFormat = 'csv' | 'xlsx';
export type TReportMerge = [startRow: number, startColumn: number, endRow: number, endColumn: number];

export const downloadReport = async (data: TReportSheet, filename: string, format: TReportFormat, signal?: AbortSignal, merges: TReportMerge[] = []) => {
  if (signal?.aborted) return;
  if (format === 'csv') {
    const worksheet = XLSX.utils.aoa_to_sheet(data);
    downloadFile({ data: [XLSX.utils.sheet_to_csv(worksheet)], filename: `${filename}.csv`, filetype: 'text/csv;charset=utf-8' });
    return;
  }

  const { Workbook } = await import('exceljs');
  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet('Report');
  data.forEach((row) => worksheet.addRow(row));
  for (const merge of merges) {
    worksheet.mergeCells(...merge);
    worksheet.getCell(merge[0], merge[1]).alignment = { horizontal: 'center' };
  }
  const contents = await workbook.xlsx.writeBuffer();
  if (signal?.aborted) return;
  downloadFile({ data: [new Uint8Array(contents)], filename: `${filename}.xlsx`, filetype: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
};
